import type { PolygonUploadResult, ProjectId, WellId } from 'common/types'

import { constructClientDispenser } from '../clientDispenserFactory'
import { axiosInstance } from '../common'
import { HttpClient } from './__generated__/http-client'
import { PolygonImportClient } from './__generated__/PolygonImport'
import { VspFileImportClient } from './__generated__/VspFileImport'

const Clients = {
  VspFileImportClient,
  PolygonImportClient,
} as const

const getClient = constructClientDispenser(Clients, HttpClient, axiosInstance)

export const importVspFilesApi = (
  projectId: ProjectId,
  wellId: WellId,
  isNegativeZ: boolean,
  isNegativeTwt: boolean,
  file: File,
): Promise<string> => {
  const client = getClient('VspFileImportClient')
  return client.vspFileImportImportVspFileToProject(
    {
      ProjectId: projectId,
      WellId: wellId,
      IsNegativeZ: isNegativeZ,
      IsNegativeTwt: isNegativeTwt,
    },
    { file },
  )
}

export const uploadPolygonsApi = (
  projectId: ProjectId,
  files: File[],
): Promise<PolygonUploadResult[]> => {
  const client = getClient('PolygonImportClient')
  return client.polygonImportAddPolygonsFromFilesToProject(projectId, { fileCollection: files })
}
